import { api } from '../utils/api';
import { API_ENDPOINTS } from '../constants/AppApiConstant';

/**
 * Authentication Service
 * Centralized API calls for authentication
 */

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  token?: string;
  id?: string;
  name?: string;
  nameAr?: string;
  email?: string;
  role?: string;
  avatar?: string;
  createdAt?: string;
  user?: {
    id?: string;
    name?: string;
    nameAr?: string;
    email?: string;
    role?: string;
    avatar?: string;
    createdAt?: string;
  };
}

export interface LogoutResponse {
  success: boolean;
  message?: string;
}

/**
 * Login user with username and password
 */
export const loginUser = async (username: string, password: string): Promise<LoginResponse> => {
  try {
    const response = await api.post<LoginResponse>(
      API_ENDPOINTS.LOGIN,
      {
        username,
        password
      },
      { requiresAuth: false }
    );
    return response;
  } catch (error) {
    console.error('Login service error:', error);
    throw error;
  }
};

/**
 * Logout current user
 */
export const logoutUser = async (): Promise<LogoutResponse> => {
  try {
    const response = await api.post<LogoutResponse>(
      API_ENDPOINTS.LOGOUT,
      {},
      { requiresAuth: true }
    );
    return response;
  } catch (error) {
    console.error('Logout service error:', error);
    // Return success even if API call fails
    // Frontend will clear local storage anyway
    return { success: true };
  }
};
